import { create } from 'zustand';

export type ThemeMode = 'system' | 'light' | 'dark';

const KEY = 'mf_theme';

function getStored(): ThemeMode {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch {
    /* ignore */
  }
  return 'system';
}

function applyTheme(mode: ThemeMode): void {
  const root = document.documentElement;
  const prefersDark =
    typeof matchMedia === 'function' && matchMedia('(prefers-color-scheme: dark)').matches;
  const isDark = mode === 'dark' || (mode === 'system' && prefersDark);
  root.classList.toggle('dark', isDark);
  root.dataset.theme = isDark ? 'dark' : 'light';
}

interface ThemeState {
  mode: ThemeMode;
  set: (m: ThemeMode) => void;
  init: () => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  mode: getStored(),

  set: (m) => {
    try {
      localStorage.setItem(KEY, m);
    } catch {
      /* ignore */
    }
    applyTheme(m);
    set({ mode: m });
  },

  init: () => {
    const m = getStored();
    applyTheme(m);
    if (typeof matchMedia === 'function') {
      const mq = matchMedia('(prefers-color-scheme: dark)');
      const listener = () => {
        if (getStored() === 'system') applyTheme('system');
      };
      mq.addEventListener?.('change', listener);
    }
    set({ mode: m });
  },
}));
